export const DETAIL_TYPE_FIELDS = {
    ICD10: ['code'],
    GRADING: ['code', 'type'],
    PATHOLOGY: ['from'],
    STATEMENT: ['code', 'from', 'freeText', 'type'],
    LABORATORY: ['code', 'from', 'freeText', 'type'],
    ACCOMPANYING_DISEASE: ['code', 'freeText'],
    FORMER_THERAPY: ['from', 'to'],
};
